import i18n from '@/i18n';
import moment from 'moment';
import { resolveDateLocale } from './date-locale';

export const formatDate = (
  date: string | Date | undefined | null,
  format?: string,
  locale?: string,
) => {
  if (!date) {
    return null;
  }

  // By default moment will convert to the local browser time
  return moment(date)
    .locale(locale ?? resolveDateLocale(i18n.language))
    .format(format);
};
